import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0c813125"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ui-message-error"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ui-message-error',
  props: {
	errorMessage: { type: String, default: "" },
	showError: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.showError || __props.errorMessage || _ctx.$slots.default)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(__props.errorMessage), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})